import { withSearch } from '@elastic/react-search-ui';
import DropDownFacetFilters from '../../../components/filter/DropDownFacetFilter';

function HARSiteSubTypeFilter({ facets, filters, removeFilter, setFilter }) {
  return (
    <DropDownFacetFilters
      facets={facets}
      fieldId="siteSubType"
      filters={filters}
      id="site-sub-type"
      label="Site subtype / narrow term"
      removeFilter={removeFilter}
      setFilter={setFilter}
    />
  );
}

export default withSearch(({ facets, filters, removeFilter, setFilter }) => ({
  facets,
  filters,
  removeFilter,
  setFilter,
}))(HARSiteSubTypeFilter);
